
import Packery from 'packery';
import shared, { statsEvent, config, showSignInModal } from 'shared/shared';
import i18n from 'shared/i18n/i18n';
import Dom from 'shared/util/dom';
import Sticky from 'shared/util/sticky';
import { default as Popover } from 'shared/widget/alert';
import Overlay from 'shared/widget/overlay';
import packDisplayShared from 'shared/pack-shared';
import { Country, ItemType, TypeIcons } from '../../../shared/constants';
import { PackRoute } from '../../../shared/util/route-constants';
import Api from "../../../shared/api";
import AssignedActivityCard from "./AssignedActivityCard";
import {$window, initTooltips} from '../../../shared/util/dom';
import {MediaQueries} from "../../../shared/util/media-query-events";
import MediaQueryEvents from "../../../shared/util/media-query-events";

const subjectPath = shared.getSubjectAreaPath();
const packDisplayCustom = (function () {

  let _data,
    _readOnlyData,
    packId;

  const localizedResource = i18n.resource;
  const localizedString = i18n.string;

  const gradeRanges = localizedResource('my.content.grade.ranges');

  const ebNoteVisible = ko.observable(true);
  const userNoteVisible = ko.observable(true);


  ebNoteVisible.subscribe(layout);
  userNoteVisible.subscribe(layout);


  const type = ko.observable('');
  const info = ko.observable();
  const titleError = ko.observable(false);
  const toBeRemoved = ko.observable(null);

  // There should only ever be one item in this observable at a time.
  const removeDisabled = ko.observable(null);

  const items = ko.observableArray([]);
  const deletedItems = ko.observableArray([]);
  const addedItems = ko.observableArray([]);
  const actualItems = ko.computed(() => addedItems().union(items()).exclude(item => deletedItems().find(dItem => dItem.contentId == item.contentId)));

  const documents = ko.computed(() => actualItems().filter(item => item.type === 'uploaded_document'));

  const editedItem = ko.observable(null);
  const editingUserNote = ko.observable(false);
  const _saving = ko.observable(false);
  const _isUserNoteVisible = ko.observable(false);


  // For creating a note on a pack item

  editedItem.subscribe((val) => {
    layout();
    if (val) {
      setTimeout(() => {
        const card = document.getElementById(getElementIdFromItemData(val));
        const textarea = card && card.querySelector('textarea.add-note-input');

        textarea && textarea.focus();

        if (model.activitiesPane) {        
          model.activitiesPane().setPaneContainerHeight();
        }

      }, 30);
    }
  });
  

  let getSessionVar,
    setSessionVar;


  // Show/hide the Pack User Note

  function layout() {
    setTimeout(() => {
      packery && packery.layout();

      if (model.activitiesPane) {
        model.activitiesPane().setPaneContainerHeight();
      }
    }, 30);
  }

  // Returns a seclector using the

  function getElementIdFromItemData(item) {
    if (typeof(item.savedContentId) !== 'undefined') {
      return `${item.type}-${item.savedContentId}`;
    }
    else {
      return `${item.type}-${item.contentId}`;
    }
  }


  function getTotalDocumentSize(initial = 0) {
    return documents().map(item => item.size).reduce((a, b) => a + b, initial);
  }


  const typeIcons = TypeIcons;

  function createNewItem(item) {
    item.note = ko.observable('');
    item.userNote = ko.observable('');
    item.userNoteIndividual = {};

    return item;
  }

  function afterContentAdded(newItem) {
    setTimeout(() => {
      const element = document.getElementById(getElementIdFromItemData(newItem));

      packery && packery.prepended(element);

      if (model.activitiesPane) {
        model.activitiesPane().setPaneContainerHeight();
      }
    }, 30);
  }

  // Link Manager Component

  const goFiles = i18n.resource('packs.graphic.organizer.files');

  const goManager = {
    selectedItem: ko.observable(),
    title: ko.observable(''),
    altTitle: ko.observable(''),
    instruction: ko.observable(''),
    modalID: 'add-GO-modal',
    selectItem: _selectItem,
    changeSelection: _changeSelection,
    submit: _addGoFile,
  };

goManager.openModal = function () {
  const modalElement = $(`#${goManager.modalID}`);

  modalElement.modal('show');
  modalElement.one('hidden.bs.modal', () => {
    _clearGOForm();
  });
  $('.add-GO-content').show();
  $('.add-GO-form').hide();
  $('.submit-GO-btn').hide();
};

function _selectItem(item) {
  goManager.selectedItem(item.name);
  $('.add-GO-content').hide();
  $('.add-GO-form').show();
  $('.submit-GO-btn').show();
}

function _changeSelection() {
  _clearGOForm();
  $('.add-GO-form').hide();
  $('.add-GO-content').show();
  $('.submit-GO-btn').hide();
}

function _addGoFile() {
  const contentId = packDisplayShared.generateUUID();
  const newItem = {};

  newItem.goTitle = goManager.selectedItem();
  newItem.goAlternateTitle = goManager.altTitle();
  newItem.goInstruction = goManager.instruction();
  newItem.type = 'graphic_organizer';
  newItem.favoriteType = 'GRAPHIC_ORGANIZER';
  newItem.contentId = contentId;
  //newItem.savedContentId = contentId;
  addedItems.unshift(createNewItem(newItem));
  $(`#${goManager.modalID}`).modal('hide');
  afterContentAdded(newItem);

  if (model.activitiesPane) {
      model.activitiesPane().addPackItem(buildGraphicOrganizer(newItem));
  }
}

function _clearGOForm() {
  goManager.selectedItem('');
  goManager.title('');
  goManager.altTitle('');
  goManager.instruction('');
}

  const linkManager = {
    url: ko.observable(''),
    cardTitle: ko.observable(''),
    cardDescription: ko.observable(''),
    legalAccepted: ko.observable(false),
    error: ko.observable({}),
    modalID: 'add-link-modal',
    validateURL: _validateURL,
    submit: _addLink,
  };

  linkManager.openModal = function () {
    const modalElement = $(`#${linkManager.modalID}`);

    modalElement.modal('show');
    modalElement.one('hidden.bs.modal', () => {
      _clearLinkForm();
    });
  };

  linkManager.url.subscribe((val) => {
    const error = linkManager.error();
    const url = packDisplayShared.urlize(linkManager.url());


    if (val && !packDisplayShared.isValidURL(url)) {
      error.url = localizedString('packs.custom.link.validation.message');
    }
    else {
      error.url = null;
    }

    linkManager.error(error);
  });

  // Validates a url for adding a link from custom packs page

  function _validateURL() {
    linkManager.error({});

    const error = {};


    if (!packDisplayShared.isValidURL(packDisplayShared.urlize(linkManager.url()))) {
      error.url = localizedString('packs.custom.link.validation.message');
    }

    if (!linkManager.cardTitle()) {
      error.title = localizedString('packs.custom.card.title.validation.message');
    }

    linkManager.error(error);

    return !(error.url || error.title);
  }

  // Used for adding a link via the customize packs page

  function _addLink() {
    if (_validateURL()) {
      const contentId = packDisplayShared.generateUUID();
      const newItem = {};

      newItem.title = linkManager.cardTitle();
      newItem.description = linkManager.cardDescription();
      newItem.url = linkManager.url();
      newItem.type = 'external_link';
      newItem.favoriteType = 'EXTERNAL_LINK';
      newItem.contentId = contentId;
      addedItems.unshift(createNewItem(newItem));
      $(`#${linkManager.modalID}`).modal('hide');
      afterContentAdded(newItem);

      if (model.activitiesPane) {
        model.activitiesPane().addPackItem(buildExternalLink(newItem));
      }
    }
  }

  function _clearLinkForm() {
    linkManager.url('');
    linkManager.cardTitle('');
    linkManager.cardDescription('');
    linkManager.error({});
  }


  /* Kahoot start */

    const kahootManager = {
        url: ko.observable(''),
        cardTitle: ko.observable(''),
        error: ko.observable({}),
        modalID: 'add-kahoot-modal',
        validateURL: _validateKahootURL,
        submit: _addKahootLink,
    };

    kahootManager.openModal = function () {
        const modalElement = $(`#${kahootManager.modalID}`);

        modalElement.modal('show');
        modalElement.one('hidden.bs.modal', () => {
            _clearKahootForm();
        });
    };

    kahootManager.url.subscribe((val) => {
        const error = kahootManager.error();
        const url = packDisplayShared.urlize(kahootManager.url());


        if (val && !packDisplayShared.isValidURL(url)) {
            error.url = localizedString('packs.custom.link.validation.message');
        } else {
            error.url = null;
        }

        kahootManager.error(error);
    });

    function _validateKahootURL() {
        kahootManager.error({});

        const error = {};


        if (!packDisplayShared.isValidURL(packDisplayShared.urlize(kahootManager.url()))) {
            error.url = localizedString('packs.custom.link.validation.message');
        }

        if (!kahootManager.cardTitle()) {
            error.title = localizedString('packs.custom.card.title.validation.message');
        }

        kahootManager.error(error);

        return !(error.url || error.title);
    }

    function _addKahootLink() {
        if (_validateKahootURL()) {
            const contentId = packDisplayShared.generateUUID();
            const newItem = {};
            newItem.title = kahootManager.cardTitle();
            newItem.url = kahootManager.url();
            newItem.type = 'kahoot';
            newItem.favoriteType = 'KAHOOT';
            newItem.contentId = contentId;
            // newItem.savedContentId = contentId;
            addedItems.unshift(createNewItem(newItem));
            $(`#${kahootManager.modalID}`).modal('hide');
            afterContentAdded(newItem);

            if (model.activitiesPane) {
                model.activitiesPane().addPackItem(buildKahootLink(newItem));
            }
        }
    }

    function _clearKahootForm() {
        kahootManager.url('');
        kahootManager.cardTitle('');
        kahootManager.error({});
    }
/* Kahoot end */


  const _deleteDocumentId = ko.observable(0);
  // Called from custom-content.jsp when
  function _deleteDocument(doc) {
    _deleteDocumentId(doc && doc.s3Key || -1);
  }

  // Called from custom-content.jsp

  function _deleteCancel() {
    _deleteDocumentId(0);
  }

  // Called from custom-content.jsp

  function _deleteConfirm(doc) {
    if (doc) {
      _proceedToRemove(doc, _validateDocument);
    }
    else {
      _clearUploadForm();
      _validateDocument();
    }
  }

  // The document manager is used for uploading documents from the customize pack screen.
  /*---------------------------*
    For Up-loading content
  *---------------------------*/

  const documentManager = {
    name: ko.observable(''),
    size: ko.observable(''),
    cardTitle: ko.observable(''),
    cardDescription: ko.observable(''),
    legalAccepted: ko.observable(false),
    percentVal: ko.observable('0%'),
    error: ko.observable(''),
    fileElementID: 'file-uploader',
    formID: 'upload-document-form',
    modalID: 'upload-document-modal',
    validateDocument: _validateDocument,
    triggerFileChooser: _triggerFileChooser,
    submit: _submit,
    documents,
    totalSize: ko.observable(0),
    exceededLimit: ko.observable(false),
    deleteDocument: _deleteDocument,
    deleteCancel: _deleteCancel,
    deleteConfirm: _deleteConfirm,
    link(item) {
      return `/${subjectPath}/custom/fetch/document/${info().owner.individualId}/${item.savedContentId}/${item.originalFilename}`;
    },
    deleteDocumentId: _deleteDocumentId,
    uploading: ko.observable(false),
  };

  documentManager.openModal = function () {
    const modalElement = $(`#${documentManager.modalID}`);

    modalElement.modal('show');

    modalElement.one('hidden.bs.modal', () => {
      _clearUploadForm();
    });
  };

  const allowedFileTypes = ['application/vnd.oasis.opendocument.text', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/rtf', 'text/rtf', 'text/plain', 'application/pdf'];
  const MAX_FILE_SIZE = 20 * 1024 * 1024;
  const MAX_TOTAL_UPLOAD_SIZE = 20 * 1024 * 1024;

  function _triggerFileChooser() {
    $(`#${documentManager.fileElementID}`).click();

    return false;
  }

  function _validateDocument() {
    documentManager.error({});
    documentManager.exceededLimit(false);
    documentManager.totalSize(0);
    _deleteDocumentId(0);

    const fileElement = document.getElementById(documentManager.fileElementID);


    if (fileElement && fileElement.files.length) {
      const file = fileElement.files[0];

      documentManager.name(file.name || '');
      documentManager.size(file.size || 0);

      if (allowedFileTypes.indexOf(file.type) === -1) {
        documentManager.error({ file: localizedString('packs.custom.upload.format.supported.message', { filename: documentManager.name() }) });
      }
      else if (file.size > MAX_FILE_SIZE) {
        documentManager.error({ file: localizedString('packs.custom.upload.file.too.large.message', { filename: documentManager.name() }) });
      }
      else if (getTotalDocumentSize(file.size) > MAX_TOTAL_UPLOAD_SIZE) {
        documentManager.totalSize(getTotalDocumentSize(file.size));
        documentManager.exceededLimit(true);
      }
      else {
        return true;
      }
    }
    else {
      documentManager.error({ file: localizedString('packs.custom.upload.no.file.message') });
    }

    return false;
  }

  function _clearUploadForm() {
    documentManager.cardTitle('');
    documentManager.cardDescription('');
    document.getElementById(documentManager.fileElementID).value = '';
    documentManager.name('');
    documentManager.size('');
    documentManager.legalAccepted(false);
    documentManager.percentVal('0%');
    documentManager.error({});
  }

  function _onFormSubmissionComplete(response) {
    documentManager.uploading(false);

    const newItem = response;
    const contentId = packDisplayShared.generateUUID();

    newItem.title = documentManager.cardTitle();
    newItem.description = documentManager.cardDescription();
    newItem.type = newItem.favoriteType.toLowerCase();
    newItem.contentId = contentId;
    addedItems.unshift(createNewItem(newItem));
    $(`#${documentManager.modalID}`).modal('hide');
    afterContentAdded(newItem);
  }

  function _beforeFormSubmission() {
    if (_validateDocument()) {
      if (!documentManager.cardTitle()) {
        documentManager.error({ title: localizedString('packs.custom.card.title.validation.message') });

        return false;
      }

      documentManager.uploading(true);

      return true;
    }

    return false;
  }

  function _submit() {
    const options = {
      beforeSubmit: _beforeFormSubmission,
      dataType: 'json',
      uploadProgress(event, position, total, percentComplete) {
        documentManager.percentVal(`${percentComplete}%`);
      },
      success(data) {
        documentManager.percentVal('100%');

        _onFormSubmissionComplete(data);

        if (model.activitiesPane) {
          model.activitiesPane().addPackItem(buildUploadedDocument(data));
        }
      },
    };

    $(`#${documentManager.formID}`).ajaxSubmit(options);

    return false;
  }

  function discardDocument(key) {
    $.post(`/${subjectPath}/custom/tempDocument/discard`, {
      s3Key: key,
    }).then((response) => {
      console.log(response);
    });
  }

  /*-- End upload document code --*/
  /*-- Does this even get called? --*/

  function switchArticle(article, id) {

    if (article.contentId === id) {
      return;
    }

    const element = document.getElementById(getElementIdFromItemData(article));
    let newArticle = Object.clone(_readOnlyData.extraPackItems.find(i => i.contentId == id), true);

    const hasBeenDeleted = deletedItems().find(i => i.contentId == id);

    newArticle = newArticle || hasBeenDeleted;
    newArticle.type = newArticle.favoriteType.toLowerCase();

    if (hasBeenDeleted) {
      const newRemovedItems = deletedItems().filter(i => i.contentId !== newArticle.contentId);

      deletedItems(newRemovedItems);
    }
    else {
      addedItems.push(newArticle);
    }

    setTimeout(() => {
      const newElement = document.getElementById(getElementIdFromItemData(newArticle));

      if (packery) {
        packery.once('layoutComplete', () => {
          deletedItems.push(article);
        });
        packery.remove(element);
        packery.prepended(newElement);
      }
    }, 10);
  }

  /*
      This is inexplicably renamed to proceedToRemove and then called from
      the view when 'remove' is clicked on the pack of a pack item card,
      or inside of _deleteConfirm.
   */

  function _proceedToRemove(packItem, callback) {
    // Is this a new custom item or something that has been persisted to the db?
    const isPersisted = !!packItem.savedContentId;

    const itemElement = document.getElementById(getElementIdFromItemData(packItem));

    if (model.activitiesPane) {
      model.activitiesPane().removePackItem(packItem);
    }


    if (packery) {
      packery.once('layoutComplete', () => {
        // newly created items that have not been persisted do not have a savedContentId
        // Technically custom types do not, but TKS takes the contentId and returns it as
        // the saved contentId as well.
        const newRemovedItem = isPersisted ? 
                                addedItems().find(i => i.savedContentId == packItem.savedContentId) : 
                                addedItems().find(i=>i.contentId === packItem.contentId);

        if (newRemovedItem) {
          if (newRemovedItem.type === 'uploaded_document') {
            discardDocument(newRemovedItem.s3Key);
          }

          const newAddedItems = isPersisted ?
                                  addedItems().filter(i => newRemovedItem.savedContentId !== i.savedContentId) :
                                  addedItems().filter(i => newRemovedItem.contentId !== i.contentId);

          addedItems(newAddedItems);
        }
        else {
          deletedItems.push(packItem);
        }
        // Reminder toBeRemoved only holds one item at a time
        toBeRemoved(null);

        if (callback && Object.isFunction(callback)) {
          callback();
        }
      });

      if (packItem.isFeatured) {
        itemElement.parentNode.removeChild(itemElement);
      }
      else {
        packery.remove(itemElement);
      }

      packery.stamp(document.querySelectorAll('.pack-display .stamp'));
      packery.layout();
    }
  }


  // Used for saving of packs after customization.

  function getPackData(ownPack) {
    const data = {};

    data.pack = {
      assetId: info().assetId,
      note: info().note(),
      gradeIds: [info().gradeRange().value],
      keywords: info().keywords || null,
      packId: ownPack ? info().packId : null,
      packImgUrl: info().packImgUrl,
      subjectIds: info().subjectIds,
      tags: info().tags,
      text: info().text().trim(),
      userNote: info().userNote(),
      userNoteIndividual: info().userNoteIndividual,
      anchorSavedContentId: info().anchorSavedContentId || null,
    };

    if (!ownPack) {
      data.pack.sourcePackId = info().packId;
    }

    data.packItems = [];

    actualItems().each((item) => {
      let content;

      if (item.contentId !== -1) {
        if (item.type === 'uploaded_document') {
          content = buildUploadedDocument(item);
        }
        else if (item.type === 'external_link') {
          content = buildExternalLink(item);
        } else if (item.type === 'graphic_organizer') {
          content = buildGraphicOrganizer(item);
        }else if (item.type === 'kahoot') {
            content = buildKahootLink(item);
        }else if (item.type === 'learning_resource') {
            content = buildLearningResource(item);
        } else {
          content = {
            contentId: item.contentId,
            favoriteType: item.favoriteType,
          };
        }

        if (item.additionalContentType) {
          content.additionalContentType = item.additionalContentType;
        }

        if (item.savedContentId) {
          content.savedContentId = item.savedContentId;
        }

        content.labelNote = item.note();
        content.userNote = item.userNote();
        content.userNoteIndividual = item.userNoteIndividual;

        data.packItems.push(content);
      }
    });

    return data;
  }

  function redirectAfterSave(id) {
    if (config.isLearningStrategy) {
      window.location = `${window.location.protocol}//${window.location.host}/${subjectPath}/ls/${id}`;
    }
    else {
      window.location = `${window.location.protocol}//${window.location.host}/${subjectPath}/${id}`;
    }
  }

  function trackCustomizeEvent() {
    const event = {
      packId,
      eventSubtype: 'customized-pack',
    };

    statsEvent(event);
  }

  function _savePack() {
    if (_saving()) {
      return;
    }

    if(!config.isLoggedIn()){
        showSignInModal();
        return;
    }

    const individualId = shared.getIndividualId();
    const ownPack = info().owner.individualId == individualId;

    if (ownPack && !packHasChanged()) {
      redirectAfterSave(packId);

      return;
    }

    const data = getPackData(ownPack);
    _saving(true);
    $.ajax({
      type: 'POST',
      url: `/${subjectPath}/custom/pack`,
      data: JSON.stringify(data),
      contentType: 'application/json',
      dataType: 'json',
      success(response) {
        _saving(false);

        if (response.result) {
          if (!ownPack) {
            setSessionVar('new-custom-pack-added');

            trackCustomizeEvent();

            setTimeout(() => {
              redirectAfterSave(response.newPackId || packId);
            }, 100);
          }
          else {
            redirectAfterSave(response.newPackId || packId);
          }
        }
        else if (response.errorMessage) {
          const element = document.querySelector('.resource-pack-top .pack-title ');

          Popover({
            content: response.errorMessage,
            element,
            width: 200,
            placement: 'left',
            theme: 'error',
          });

          titleError(true);
        }
        else {
          Overlay(localizedString('packs.custom.generic.error.title'), localizedString('packs.custom.generic.error.message'));
        }
      },
      error() {
        _saving(false);
        Overlay(localizedString('packs.custom.generic.error.title'), localizedString('packs.custom.generic.error.message'));
      },
    });
  }

  function itemEqual(source, target) {
    if (source.s3Key) {
      return source.s3Key == target.s3Key;
    }
    else if (source.url) {
      return source.url == target.url;
    }
    else if (source.savedContentId) {
      return source.savedContentId == target.savedContentId;
    }

    return source.contentId == target.contentId;
  }

  // Checks to see if there have been any changes to the current Pack.
  // called from _save() and discard()

  function packHasChanged() {
    let hasChanged = false;

    if (addedItems().length || deletedItems().length) {
      return true;
    }

    if (info().text() !== _readOnlyData.pack.text) {
      return true;
    }

    if ((!_readOnlyData.pack.gradeIds && info().gradeRange().value) || info().gradeRange().value !== _readOnlyData.pack.gradeIds[0]) {
      return true;
    }

    if ((info().note() || _readOnlyData.pack.note) && (info().note() != _readOnlyData.pack.note)) {
      return true;
    }

    if ((info().userNote() || _readOnlyData.pack.userNote) && (info().userNote() != _readOnlyData.pack.userNote)) {
      return true;
    }

    items().each((item) => {

      if (item.contentId !== -1) {
        const originalItem = _readOnlyData.packItems.find(i => itemEqual(item, i));


        if (originalItem &&((item.note() || originalItem.labelNote) && (item.note() != originalItem.labelNote))) {
          hasChanged = true;

          return false;
        }

        if (originalItem && ((item.userNote() || originalItem.userNote) && (item.userNote() != originalItem.userNote))) {
          hasChanged = true;

          return false;
        }
      }
    });

    return hasChanged;
  }

  var model = {
    afterRender,
    buildCustomizeHref,
    togglePearDeckMenu,
    config,
    ebNoteVisible,
    userNoteVisible,
    info,
    items: ko.computed(() => {
      return actualItems().filter((item) => {
        // return everything if the typs is 'All';
        if (model.selectedContentType() == i18n.string('packs.type.s')) {
          return true;
        }
        return (model.type().toLowerCase() == item.type.toLowerCase());
      })
    })
    ,
    typeIcons,
    gradeRanges,
    toggleChecked(model, e) {
      e.stopImmediatePropagation();

      if (e.currentTarget.checked) {
        removeDisabled(null);
      }
      else {
        removeDisabled(model);
      }

      return true;
    },

    // Called from the jsp file when the 'x' is clicked on a pack item.
    // This can be a custom pack item or a default pack item.

    remove(model) {
      // Sets observable in turn showing the 'back' of the card, with 'Remove this Item?'
      // nothing to do with final removal, should only hold one model at a time.

      toBeRemoved(model);

      if (model.isAnnotatedContent && model.isAnnotatedContent === true) {
        removeDisabled(model);
      }
    },

    cancelRemove() {
      toBeRemoved(null);
      removeDisabled(null);
    },
    proceedToRemove: _proceedToRemove,
    save: _savePack,
    saving: _saving,
    discard() {
      if (packHasChanged()) {
        const buttons = [
          {
            label: localizedString('packs.custom.discard.changes.cancel'),
            onClick() {
            },
          },
          {
            label: localizedString('packs.custom.discard.changes.confirm'),
            onClick() {
              addedItems().each((item) => {
                if (item.type === 'uploaded_document') {
                  discardDocument(item.s3Key);
                }
              });
              document.location.hash = '#/pinboard';
            },
          },
        ];

        Overlay(localizedString('packs.custom.discard.changes.modal.title'), localizedString('packs.custom.discard.changes.modal.body'), null, buttons, true);
      }
      else {
        document.location.hash = '#/pinboard';
      }
    },
    toBeRemoved,
    removeDisabled,
    documentManager,
    linkManager,
    goManager,
    kahootManager,
    goFiles,
    switchArticle,
    editedItem,
    editingUserNote,
    layout,
    titleError,
    initTooltips,
    view: ko.observable('custom'),
    isUserNoteVisible: _isUserNoteVisible,
    isCtaDisabled: ko.observable(true),
    selectedContentType: ko.observable(i18n.string('packs.type.s')),
    types: ko.computed(() => {
      const annotatedTypes = {
        key: 'annotated',
        count: 0,
        order: 1,
        icon: '',
        name: i18n.string('packs.type.annotated'),
      };
      let newTypes = [{
        key: '',
        count: items().length,
        order: -1,
        icon: '',
        name: i18n.string('packs.type.s'),
      }].union(Object.values(Object.map(items().groupBy('type'), (key, value) => ({
        key,
        count: value.length,
        order: Object.keys(typeIcons).indexOf(key),
        icon: typeIcons[key],
        name: i18n.string(`packs.type.${key}s`),
      }))).sortBy('order'));

      Object.values(items()).flatten().forEach((item) => {
        if (item.isAnnotatedContent) {
          annotatedTypes.count++;
        }
      });

      if (annotatedTypes.count > 0) {
        newTypes = newTypes.union(annotatedTypes);
      }

      return newTypes;
    }),
    type,

  };


  // --- VM Subscriptions --- //

  // Update pack items within the Activities Pane whenever the userNote gets updated

  model.items.subscribe((items) => {
    items.forEach((item) => {
      if (item.userNote && item.userNote.getSubscriptionsCount() === 0) {
        item.userNote.subscribe(() => {
          if (model.activitiesPane) {
            model.activitiesPane().updatePackItem(ko.mapping.toJS(item));
          }
        });
      }
    });
  });


  // Other old stuff

  var packery = null;

  const initPinboard = _.debounce(() => {
    packery && packery.destroy();

    const elem = document.querySelector('.pack-display .items');

    packery = new Packery(elem, {
      itemSelector: '.pack-display .pinboard-item',
      columnWidth: '.pack-display .item',
      stamp: '.pack-display .stamp',
    });

    const mqe = new MediaQueryEvents();

    mqe.on(MediaQueries.MEDIUM, () => {
      packery.layout();
    });
  }, 0);

  model.type.subscribe((val) => {
    if (val == 'annotated') {
      model.selectedContentType(i18n.string('packs.type.annotated'));
    } else if (val) {
      model.selectedContentType(i18n.string(`packs.type.${val}s`));
    } else {
      model.selectedContentType(i18n.string('packs.type.s'));
    }
  });

  function onView(data) {
    _readOnlyData = data;
    _data = Object.clone(data, true);
    deletedItems([]);
    addedItems([]);
    _data.packItems.each((item, index) => {
      if (item.favoriteType == 'ADDITIONALCONTENT') {
        item.type = item.additionalContentType;
      }
      else if (item.favoriteType == 'ASSEMBLY') {
        item.type = item.assetType;
      }
      else if (item.favoriteType == 'EXCERPT') {
        item.type = `${item.favoriteType}_${item.sourceContentType}`;
      }
      else {
        item.type = item.favoriteType;
      }

      item.type = item.type.toLowerCase();
      item.order = index;
      item.isFeatured = index === 0;
      item.note = ko.observable(item.note || item.labelNote || '');
      item.userNote = ko.observable(item.userNote || '');
      item.contentId = item.contentId || item.savedContentId || packDisplayShared.generateUUID();
      item.userNoteIndividual = item.userNoteIndividual || {};
      item.title = item.title || item.originalFilename;
    });

    items(_data.packItems);

    // add the custom content div to items

    items.push({ contentId: -1, type: 'custom-content' });

    if (_data.pack) {
      _data.pack.gradeRange = ko.observable(gradeRanges.find(grade => _data.pack.gradeIds && _data.pack.gradeIds.find(id => grade.value == id)));
      _data.pack.text = ko.observable(_data.pack.text);
      _data.pack.note = ko.observable(_data.pack.note || '');
      _data.pack.userNote = ko.observable(_data.pack.userNote || '');
      info(_data.pack);
    }

    initPinboard();

    /*
    PAC-2380
     */
    // Sticky.init('.pack-display .pack-display-pinnable', 146);


    // Set the `customPackDetail` of the ActivitiesPane
    // We need to replace the object because this object has the necessary observables to keep things in sync

    if (config.isActivity) {
      model.activitiesPane().setCustomPack(info());
    }
  }

  /**
     * Callback after "pack-custom-items" template renders
     */

  function afterRender() {
    $('.remove-pack, .rp-close').tooltip();
    initTooltips();
  }

  function togglePearDeckMenu(data, event) {
    const gaTag = !config.isStudent() ?
        `Pear Deck Resource|Pear Deck Teacher Copy|Click on A Resource - Pear Deck - ${this.title}` :
        `Pear Deck Resource|Pear Deck Student Join|Click on A Resource - Pear Deck - ${this.title}`;
    const gaElement = !config.isStudent() ?
        document.getElementById('pear_deck-teacher-link') :
        document.getElementById('pear_deck-student-link');
    if (config.isLoggedIn()) {
      gaElement.setAttribute('data-ga', gaTag);
      event.preventDefault();
      const el = event.target.closest('.pack-display-item');
      $(".pear-deck-title").html(this.title);
      $(".pear-deck-description").html(this.description);
      $(".pear-deck-teacher-link").attr('href', this.url);
      $("#pear-deck-modal").modal('show');
    }
    else {

      // Pac 3168: Pear Deck - Sign in with Access ID. Click Pear Deck Card. Can only make the Sign In Model appear once.
      showSignInModal();
      // if (model.ilmodal !== '') {
      //   model.ilmodal.show();
      // }
      // else {
      //     console.log("undefined")
      //     model.ilmodal = new IndividualLoginModal();
      //     model.ilmodal.show();
      // }
    }
  }


  /**
     * Build the URL for a pack item
     *
     * @param {Object} item
     * @returns {String}
     */

  function buildCustomizeHref(item) {
    switch (item.type) {
      case ItemType.ARTICLE:
        return PackRoute.ARTICLE.replace(':packId', packId).replace(':contentId', item.contentId);

      case ItemType.AUDIO:
      case ItemType.IMAGE:
      case ItemType.INTERACTIVE:
      case ItemType.VIDEO:
        return PackRoute.MEDIA_OVERLAY.replace(':packId', packId).replace(':contentId', item.contentId);

      case ItemType.MAGAZINE:
        return PackRoute.MAGAZINE.replace(':packId', packId).replace(':contentId', item.contentId);

      case ItemType.SUPPLEMENTAL:
        return PackRoute.SUPPLEMENTAL.replace(':packId', packId).replace(':contentId', item.contentId);

      case ItemType.GRAPHIC_ORGANIZER:
        const goFile = goFiles.find(file => file.name == item.goTitle);
        return `/resources/pdf/graphic-organizer/${goFile.value}`;

      case ItemType.LEARNING_RESOURCE:
        const indId = info().owner.individualId;
        const { originalFilename, savedContentId } = item;
        return `/${subjectPath}/custom/fetch/resource/${indId}/${savedContentId}/${originalFilename}`;

      case ItemType.EXTERNAL_LINK:
      case ItemType.KAHOOT:
        // Added and modified logic from kahoot urlMakers method from pinboard.js
        // TODO: create one method to handle both cases of custom url creation
        
        let itemUrl = item.url.trim();
        
        if (config.isStudent()) {
          return `https://kahoot.it`;
        } else {
          if (itemUrl.indexOf('http') !== 0) {
              itemUrl = `https://${itemUrl}`;
          }
          return itemUrl;
        }

      case ItemType.UPLOADED_DOCUMENT:
          return `/${subjectPath}/custom/fetch/document/${info().owner.individualId}/${item.savedContentId}/${item.originalFilename}`;

      case ItemType.WEBSITE:
        return item.additionalContentIdentifier;

      default:
        return '';
    }
  }


  /**
     * Build an uploaded document pack item
     *
     * @param {Object} item
     * @returns {Object}
     */

  function buildUploadedDocument(item) {
    return {
      mimeType: item.mimeType,
      originalFilename: item.originalFilename,
      favoriteType: item.favoriteType,
      title: item.title,
      description: item.description,
      s3Key: item.s3Key,
    };
  }
  /**
     * Build a learning resource pack item
     *
     * @param {Object} item
     * @returns {Object}
     */

  function buildLearningResource(item) {
    return {
      mimeType: item.mimeType,
      originalFilename: item.originalFilename,
      favoriteType: item.favoriteType,
      title: item.title,
      description: item.description,
      s3Key: item.s3Key,
    };
  }

  //Configure Assigned Activity Card

  function configureAssignedActivityCard(id) {

    Api.Snack.fetchAllSnacks(id).then(
      (data) => {
        if (data.assignment) {
          assignment(data.assignment);
        }

        if (data.snacks) {
          data.snacks.forEach((item) => {
            let assignedActivityCard = new AssignedActivityCard(item);
            assignedActivities(assignedActivities().add(assignedActivityCard));
          })
        }

      }
    )

  }


  /**
     * Build an external link pack item
     *
     * @param {Object} item
     * @returns {Object}
     */

  function buildExternalLink(item) {
    return {
      url: item.url,
      favoriteType: item.favoriteType,
      title: item.title,
      description: item.description,
    };
  }
  
  /**
    * Build kahoot link pack item
    *
    * @param {Object} item
    * @returns {Object}
    */

 function buildKahootLink(item) {
   return {
     url: item.url,
     favoriteType: item.favoriteType,
     title: item.title
   };
 }

 /**
    * Build an graphic organizer pack item
    *
    * @param {Object} item
    * @returns {Object}
    */

  /**
   * Build an graphic organizer pack item
   *
   * @param {Object} item
   * @returns {Object}
   */

  function buildGraphicOrganizer(item) {
    return {
      goTitle: item.goTitle,
      title: item.goAlternateTitle ? item.goAlternateTitle : item.goTitle,
      goAlternateTitle: item.goAlternateTitle,
      favoriteType: item.favoriteType,
      goInstruction: item.goInstruction,
    };
  }
  

  function init(data, id, type, router) {
    packId = id;
    packDisplayShared.onCustomize(packId);
    getSessionVar = packDisplayShared.getSessionVar;
    setSessionVar = packDisplayShared.setSessionVar;

    documentManager.formatFileSize = packDisplayShared.formatFileSize;
    onView(data, router);
    cleanType(!type);
    setTimeout(() => {
      // need setTimeout so element can load in DOM
      const toggleShow = () => {
        $('.dropdown.content-types').hasClass('show') ? $('.dropdown.content-types').removeClass('show') : $('.dropdown.content-types').addClass('show');
      };
      
      const toggleBtn = $('#pack-content-type-filter');
      if (toggleBtn && !toggleBtn.data('event')) {
        toggleBtn.data('event', true)
        toggleBtn.on('click', toggleShow)
      }
      
      const contentTypeAnchors = $('.content-type-dd-menu-anchor');
      const ulParent = $(contentTypeAnchors.parent()).parent();
      
      if (!ulParent.data('event')) {
        ulParent.data('event', true)
      }
      contentTypeAnchors.on('click', toggleShow)
    }, 100)
  }

  function cleanType(clear) {
    if (clear && type()) {
      type('');
    }
  }

  return {
    init,
    model,
    onView,
    '/:type': function (view, _type) {
      if (_type && _type != type()) {
        type(_type);
      }
      if (_type == 'annotated') {
        type(_type);
      }
    },
  };
}());

export default packDisplayCustom;



// WEBPACK FOOTER //
// ./javascript/app/page/display/includes/customize.js